import { cn } from '@lyearn/style';

import { BASE_CLASSNAME } from '../components/Player/OptionsListItem/consts';
import { renderKeyCodeLabel } from '../components/Player/OptionsListItem/renderers';
import { OptionsListItemTypeEnum } from '../single-select/types';

type RightOptionItemConfig = {
  [key in OptionsListItemTypeEnum]: {
    renderKeyCodeContent: (label: string) => React.ReactNode;
    classes?: {
      listItem: string;
    };
  };
};

export const MTF_RIGHT_OPTION_ITEM_CONFIG: RightOptionItemConfig = {
  [OptionsListItemTypeEnum.Correct]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
  [OptionsListItemTypeEnum.Default]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-primary' }),
    classes: {
      listItem: cn(BASE_CLASSNAME, 'hover:border-border-dark bg-bg-secondary border-divider'),
    },
  },
  [OptionsListItemTypeEnum.Incorrect]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
  [OptionsListItemTypeEnum.Missed]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
  [OptionsListItemTypeEnum.Selected]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
  [OptionsListItemTypeEnum.Answered]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-primary' }),
  },
  // match-the-following never produces these types (they're specific to WeightedOption
  // single-select questions), but the config must stay exhaustive over the shared enum.
  [OptionsListItemTypeEnum.PartiallyCorrect]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
  [OptionsListItemTypeEnum.PartiallyCorrectMissed]: {
    renderKeyCodeContent: (label: string) =>
      renderKeyCodeLabel({ label, className: 'text-text-white' }),
  },
};
